import type { TOC } from '@ember/component/template-only';
import type { ItemDetailsSignature } from './utils.gts';

/** Fallback card details: overview text */
const DefaultDetails: TOC<ItemDetailsSignature> = <template>
  {{#if (overview @data)}}
    <p
      class="text-base-content/70 mt-1 line-clamp-2 min-w-0 text-sm break-words"
    >
      {{overview @data}}
    </p>
  {{/if}}
</template>;

function overview(data: Record<string, unknown> | null): string | null {
  return (data?.overview ?? data?.description) as string | null;
}

export default DefaultDetails;
